import { render, staticRenderFns } from "./PoliciesIcons.vue?vue&type=template&id=43eee745&"
import script from "./PoliciesIcons.vue?vue&type=script&lang=ts&"
export * from "./PoliciesIcons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports